module.exports = __webpack_public_path__ + "static/img/par-hongwen.412ac48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/par-hongwen.png
// module id = 0EJQ
// module chunks = 2